import { reducer } from './newCollection';

export const TYPE = 'INSPECTION_CONSENT';

export const urls = {
    getInspectionConsent: '/api/inspection/consent',
    postAdData: '/api/inspection/ad',
    previewAd: '/api/inspection/ad/preview',
    getCarCategoryRules: '/api/categories'
};

const initialState = {
    inspectionConsentData: {},
    isInspectionConsentFetching: true,
    isInspectionSubmitting: false,
    isInspectionPosting: false,
    isPreviewAdSubmitting: false,
    isCarRulesFetching: false,
    carRules: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case 'REQUEST_INSPECTION_CONSENT_DATA': {
            return {
                ...state,
                isInspectionConsentFetching: true
            };
        }
        case 'RECEIVE_INSPECTION_CONSENT_DATA': {
            return {
                ...state,
                inspectionConsentData: action.data,
                isInspectionConsentFetching: false
            };
        }
        case 'ERROR_INSPECTION_CONSENT_DATA': {
            return {
                ...state,
                inspectionConsentData: action.data,
                isInspectionConsentFetching: false
            };
        }
        case 'REQUEST_SUBMIT_INSPECTION_DATA': {
            return {
                ...state,
                isInspectionSubmitting: true
            };
        }
        case 'RESPONSE_POST_SUBMIT_INSPECTION_DATA': {
            return {
                ...state,
                inspectionConsentData: action.data,
                isInspectionSubmitting: false
            };
        }
        case 'ERROR_POST_SUBMIT_INSPECTION_DATA': {
            return {
                ...state,
                isInspectionSubmitting: false
            };
        }
        case 'REQUEST_SUBMIT_INSPECTION_PRICE_DATA_PREVIEW': {
            return {
                ...state,
                isPreviewAdSubmitting: true
            };
        }
        case 'RESPONSE_POST_SUBMIT_INSPECTION_PRICE_DATA_PREVIEW':
        case 'ERROR_POST_SUBMIT_INSPECTION_PRICE_DATA_PREVIEW': {
            return {
                ...state,
                isPreviewAdSubmitting: false
            };
        }
        case 'REQUEST_SUBMIT_INSPECTION_PRICE_DATA': {
            return {
                ...state,
                isInspectionPosting: true
            };
        }
        case 'RESPONSE_POST_SUBMIT_INSPECTION_PRICE_DATA':
        case 'ERROR_POST_SUBMIT_INSPECTION_PRICE_DATA': {
            return {
                ...state,
                isInspectionPosting: false
            };
        }
        case 'REQUEST_CAR_CATEGORY_RULES': {
            return {
                ...state,
                isCarRulesFetching: true
            };
        }
        case 'RECEIVE_CAR_CATEGORY_RULES': {
            return {
                ...state,
                isCarRulesFetching: false,
                carRules: action.data
            };
        }
        case 'ERROR_CAR_CATEGORY_RULES': {
            return {
                ...state,
                isCarRulesFetching: false,
                carRules: action.data
            };
        }
        default:
            return reducer(state, action, TYPE);
    }
};
